module.exports = __webpack_public_path__ + "img/ru.c33e75e4.svg";